import { ColumnProps } from "antd/lib/table";
import { Button, Modal } from "antd";
import * as React from "react";
import { IDocument } from "src/services/interfaces/IDocument";
import DocumentService from "src/services/api/Document.service";
import { Dispatch, SetStateAction } from "react";

export const Columns = (
  documentService: DocumentService,
  setLoading: Dispatch<SetStateAction<boolean>>,
  setDeleteCertificateSuccess: Dispatch<SetStateAction<boolean>>,
  setDownloadCertificateSuccess: Dispatch<SetStateAction<boolean>>,
  loading: boolean
) => {
  const cols = [
    {
      title: "Certidão",
      dataIndex: "description",
      width: 30,
      key: "description"
    },
    {
      title: "Arquivo",
      dataIndex: "fileName",
      width: 30,
      key: "fileName"
    },
    {
      title: "Envio",
      dataIndex: "uploadDate",
      width: 30,
      key: "uploadDate"
    },
    {
      title: "Download",
      render: (props: IDocument) => {
        return (
          <Button
            onClick={() => {
              setLoading(true);
              setDownloadCertificateSuccess(false);
              documentService.downloadDocumentByPath(props).finally(() => {
                setLoading(false);
                setDownloadCertificateSuccess(true);
              });
            }}
            ghost
            type="primary"
            shape="circle"
            icon="download"
            size="large"
            loading={loading}
            style={{
              fontSize: "20px",
              color: "#32bf72",
              borderColor: "#32bf72",
              marginLeft: "12px"
            }}
          />
        );
      },
      width: 30
    },
    {
      title: "Excluir",
      render: (props: IDocument) => {
        return (
          <Button
            ghost
            onClick={() => {
              Modal.confirm({
                title: "Deseja realmente excluir esta Certidão?",
                onOk: () => {
                  setLoading(true);
                  setDeleteCertificateSuccess(false);
                  documentService.deleteByFileId(props.id).finally(() => {
                    setLoading(false);
                    setDeleteCertificateSuccess(true);
                  });
                }
              });
            }}
            type="primary"
            loading={loading}
            shape="circle"
            icon="delete"
            size="large"
            style={{
              fontSize: "20px",
              color: "#32bf72",
              borderColor: "#32bf72",
              marginLeft: "2px"
            }}
          />
        );
      },
      width: 30
    }
  ] as Array<ColumnProps<IDocument>>;

  return cols;
};



// WEBPACK FOOTER //
// ./src/pages/step-flow/steps/certificates/Columns.tsx